module.exports = __webpack_public_path__ + "img/05.941ffced.png";